import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
const UpdateItemDossierController = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemDossierController.url(args, options),
    method: 'put',
})

UpdateItemDossierController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/item-dossier/{itemDossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
UpdateItemDossierController.url = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            itemDossier: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        itemDossier: typeof args.itemDossier === 'object'
        ? args.itemDossier.id
        : args.itemDossier,
    }

    return UpdateItemDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{itemDossier}', parsedArgs.itemDossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
UpdateItemDossierController.put = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemDossierController.url(args, options),
    method: 'put',
})

export default UpdateItemDossierController